/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { healthCheckGetApiV3HealthCheck } from "../../funcs/healthCheckGetApiV3HealthCheck.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$healthCheckGetApiV3HealthCheck: ToolDefinition = {
  name: "health-check-get-api-v3-health-check",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await healthCheckGetApiV3HealthCheck(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
